/*
 * @Author: Json Chen
 * @Date: 2021-07-14 11:41:14
 * @LastEditTime: 2021-07-16 15:04:11
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/CheckboxList/index.tsx
 */

import { Checkbox } from 'antd';
import React, { ReactNode } from 'react';
import styles from './style.module.less';
interface ItemObj {
  [k: string]: any;
}

interface IProps {
  value: ItemObj[];
  list: ItemObj[];
  itemKey: string;
  className?: string;
  disables?: Array<boolean | undefined>;
  showIndexs?: number[];
  onChange: (i: ItemObj[]) => void;
  renderItem?: (i: ItemObj[]) => ReactNode;
}

const CheckboxList = ({
  value = [],
  list = [],
  itemKey,
  className,
  disables,
  showIndexs,
  onChange,
  renderItem,
}: IProps) => {
  const _onChange = ({ target }, item) => {
    const checkedIndex = value.findIndex((v) => v[itemKey] === item[itemKey]);
    if (checkedIndex > -1) {
      onChange(value.filter((_, i) => i !== checkedIndex));
    } else {
      onChange(value.concat(item));
    }
  };
  return (
    <React.Fragment>
      {list.map((item, index) => {
        const checked = (value || []).some((v) => v[itemKey] === item[itemKey]);
        const disabled =
          disables && disables.length ? !!disables[index] : false;
        const show =
          showIndexs && showIndexs.length ? showIndexs.includes(index) : true;
        return (
          <Checkbox
            key={index}
            className={`${styles.checkbod} ${
              show ? styles.show : styles.hide
            } ${className || ''}`}
            checked={checked}
            disabled={disabled}
            onChange={(e) => _onChange(e, item)}>
            {renderItem && renderItem(item)}
          </Checkbox>
        );
      })}
    </React.Fragment>
  );
};

export default CheckboxList;
